import React from 'react'
import './Gurudev_banner.css'

const Gurudev_banner = ({ image }) => {
    return (
        <section className='Gurudev_banner_sec'>
            <div className='container'>
                <div className='banner_div'>
                    <img className='banner_img' src={image} alt="gurudev-banner" />
                    <div className='banner_overlay'></div>
                </div>
            </div>
        </section>
    )
}

export default Gurudev_banner